// 1/1/2021

export default function formatDate_mm_dd_yyyy(dateString) {
  return new Date(dateString).toLocaleDateString("en-US", {
    timeZone: "UTC",
  });
}
